import React, { useState } from "react";
import styles from "./Home.module.scss";
import Constants from "../../Constants/Constants";
import axios from "axios";
import InlineLoader from "../../Components/InlineLoader/InlineLoader";
import { ReactComponent as CrossIcon } from "../../Assets/Icons/Cross.svg";

function Home() {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const searchHandler = async (
    event: React.MouseEvent<HTMLButtonElement>,
    searchText: string
  ) => {
    event.preventDefault();
    setSuccess(false);
    if (searchText) {
      if (!loading) {
        try {
          setError("");
          setLoading(true);
          const { data } = await axios.post(`${Constants.apiUrl}/home/search`, {
            search: searchText,
          });
          if (data?.success === true) {
            setLoading(false);

            setSuccess(true);
          } else {
            throw Error("");
          }
        } catch (error: any) {
          console.log("error", error);
          if (error?.response?.data) {
            setError(error?.response?.data?.message);
          } else {
            setError("An error occured, Please try again later");
          }
          setLoading(false);
        }
      }
    } else {
      setError("Search field cannot be empty");
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainCard}>
        <div className={styles.cardContent}>
          <p>View your current job status by entering details below:</p>
          <form className={styles.formContainer}>
            <div className={styles.inputContainer}>
              <input
                type="text"
                className={styles.input}
                placeholder="Type your phone number or job number"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              {searchText && (
                <CrossIcon
                  className={styles.icon}
                  onClick={() => setSearchText("")}
                />
              )}
            </div>
            <button
              type="submit"
              className={styles.customBtn}
              onClick={(e) => searchHandler(e, searchText)}
            >
              SEARCH
            </button>
          </form>
        </div>
        {loading && <InlineLoader />}
      </div>
      {success && (
        <div className={styles.successContainer}>
          <p className={styles.success}>
            Thank you! We've found your job. A confirmation with your job status
            has been sent to your registered mobile number/email. Please check
            your messages. We'd also love your feedback to help us serve you
            better!
          </p>
        </div>
      )}
      {error && (
        <div className={styles.errorContainer}>
          <p className={styles.error}>{error}</p>
        </div>
      )}
    </div>
  );
}

export default Home;
